"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import FormGroup from "./form-group.js";
import Hint from "./hint.js";
export function createFieldComponent(Component) {
    return React.forwardRef(function FieldComponent(_a, ref) {
        var { block, children, direction = "vertical", hint, hints, invalidHint, label, valid, validHint } = _a, props = __rest(_a, ["block", "children", "direction", "hint", "hints", "invalidHint", "label", "valid", "validHint"]);
        return (_jsxs(FormGroup, { ref: ref, block: block, direction: direction, label: label, children: [_jsx(Component, Object.assign({ block: block, valid: valid }, props, { children: children })), hints, validHint && (valid === "valid" || valid === true) && _jsx(Hint, { valid: valid, children: validHint }), hint && _jsx(Hint, { children: hint }), invalidHint && (valid === "invalid" || valid === false) && _jsx(Hint, { valid: valid, children: invalidHint })] }));
    });
}
export default createFieldComponent;
//# sourceMappingURL=create-field-component.js.map